import { APICore } from './apiCore';

const api = new APICore();

type UpdateUserData = {
    uuid: string,
    uuid_edit: string
    permission: number
    email: string
    user_name: string
    type_user_id: number
    password: string
    uuid_clinic: string
    reference_id: string
    name: string
    last_name: string
    birth_date: string
    phone: string
    emergency_phone: string
    birth_address: string
    address: string
    height: number
    Weight: number
    gender_id: number
    photo: string
    blood_type?: number
    about_user: string
    unit_temperature_id: number
    unit_weight_id: number
    unit_height_id: number
    emergencyName?: string
    emergencyCellphone?: string
    emergencyRelationship?: string
};
type PathologyUserData = {
    uuid: string,
    uuid_edit: string
    DiagnosticDate: string
    DischargeDate: string
    Comment: string
    pathology_type: number
};
type UpdatePathologyUserData = {
    uuid: string,
    uuid_edit: string
    DiagnosticDate: string
    DischargeDate: string
    Comment: string
    PathologyUserId: number
    pathology_type: number
    StatusPathology: string

};
type MedicineUserData = {
    uuid: string,
    uuid_edit: string
    StartTreatmentDate: string
    EndTreatmentDate: string

    Dose: string
    TreatmentDays: string
    TimesDay: string

    Medicine_type: number
    ActivePrinciple: number
    Concentration: number
    PharmaceuticalForm: number
    Comment: string

};
type UpdateMedicineUserData = {
    uuid: string,
    uuid_edit: string
    StartTreatmentDate: string
    // EndTreatmentDate:string 

    Dose: string
    TreatmentDays: string
    TimesDay: string

    MedicineUserId: number
    Medicine_type: number
    finished_doctor: string

};

function getUserData(params: { uuid: string }) {
    const baseUrl = '/getUserInfo/';
    const payload = {
        uuid: params.uuid,
    }
    // console.log( payload);
    return api.create(`${baseUrl}`, payload);
}
function getUserClinic(params: { uuid: string }) {
    const baseUrl = '/GetUserClinic/';
    const payload = {
        uuid: params.uuid,
    }
    // console.log( payload);
    return api.create(`${baseUrl}`, payload);
}

function getUserParameters(params: { uuid: string, parameterType: string }) {
    const baseUrl = '/getUserParameters/';
    const payload = {
        uuid: params.uuid,
        parameterType: params.parameterType,
    }
    // console.log( payload);
    return api.create(`${baseUrl}`, payload);
}

function setParameterState(params: { uuid: string, measurementType: number }) {
    const baseUrl = '/setParameterState/';
    const payload = {
        uuid: params.uuid,
        measurementType: params.measurementType,
    }
    // console.log( payload);
    return api.create(`${baseUrl}`, payload);
}

function getUserNotifications(params: { uuid: string, measurement_type: string, notification_level: string, notification_status: string }) {
    const baseUrl = '/getUserNotifications/';
    const payload = {
        uuid: params.uuid,
        measurement_type: params.measurement_type,
        notification_level: params.notification_level,
        notification_status: params.notification_status
    }
    // console.log( payload);
    return api.create(`${baseUrl}`, payload);
}

function updateUserParameters(params: {
    uuid: string,
    criticalHigh: string,
    normalMax: string,
    normalMin: string,
    criticalLow: string,
    comment: string,
    type: string
}) {
    const baseUrl = '/updateUserParameters/';
    const payload = {
        uuid: params.uuid,
        criticalHigh: params.criticalHigh,
        normalMax: params.normalMax,
        normalMin: params.normalMin,
        criticalLow: params.criticalLow,
        comment: params.comment,
        type: params.type
    }
    // console.log( payload);
    return api.create(`${baseUrl}`, payload);
}

function updateUserParameters2(params: {
    uuid: string,
    criticalHigh1: string,
    normalMax1: string,
    normalMin1: string,
    criticalLow1: string,
    criticalHigh2: string,
    normalMax2: string,
    normalMin2: string,
    criticalLow2: string,
    comment: string,
    type: string
}) {
    const baseUrl = '/updateUserParameters2/';
    const payload = {
        uuid: params.uuid,
        criticalHigh1: params.criticalHigh1,
        normalMax1: params.normalMax1,
        normalMin1: params.normalMin1,
        criticalLow1: params.criticalLow1,

        criticalHigh2: params.criticalHigh2,
        normalMax2: params.normalMax2,
        normalMin2: params.normalMin2,
        criticalLow2: params.criticalLow2,

        comment: params.comment,
        type: params.type
    }
    return api.create(`${baseUrl}`, payload);
}

function updateUserParameters4(params: {
    uuid: string,
    criticalHigh1: string,
    normalMax1: string,
    normalMin1: string,
    criticalLow1: string,

    criticalHigh2: string,
    normalMax2: string,
    normalMin2: string,
    criticalLow2: string,

    criticalHigh3?: string,
    normalMax3?: string,
    normalMin3?: string,
    criticalLow3?: string,

    criticalHigh4: string,
    normalMax4: string,
    normalMin4: string,
    criticalLow4: string,

    comment: string,
    type: string
}) {
    const baseUrl = '/updateUserParameters4/';
    const payload = {
        uuid: params.uuid,
        criticalHigh1: params.criticalHigh1,
        normalMax1: params.normalMax1,
        normalMin1: params.normalMin1,
        criticalLow1: params.criticalLow1,

        criticalHigh2: params.criticalHigh2,
        normalMax2: params.normalMax2,
        normalMin2: params.normalMin2,
        criticalLow2: params.criticalLow2,

        /*         criticalHigh3: params.criticalHigh3,
                normalMax3: params.normalMax3,
                normalMin3: params.normalMin3,
                criticalLow3: params.criticalLow3, */

        criticalHigh4: params.criticalHigh4,
        normalMax4: params.normalMax4,
        normalMin4: params.normalMin4,
        criticalLow4: params.criticalLow4,

        comment: params.comment,
        type: params.type
    }
    return api.create(`${baseUrl}`, payload);
}

function updateUser(user: UpdateUserData) {
    const baseUrl = '/updateUser/';
    const payload = user

    return api.create(`${baseUrl}`, payload);
}

function getUsers(params: { TypeUser: number, uuid_edit: string }) {
    const baseUrl = '/getUsers/';
    const payload = {
        type_user_id: params.TypeUser,
        uuid_edit: params.uuid_edit
    }

    return api.create(`${baseUrl}`, payload);
}

function getUserInfo(params: { uuid_user: string, user_name: string, TypeUser: number }) {
    const baseUrl = '/GetUserInfo/';
    const payload = {
        email: "",
        user_name: params.user_name,
        password: "",
        reference_id: "",
        name: "",
        last_name: "",
        birth_date: "",
        phone: "",
        gender_id: 0,
        address: "",
        type_user_id: params.TypeUser
    }

    return api.create(`${baseUrl}`, payload);
}
/*******************************************************************************/
function GetActivePrinciple(params: { uuid: string }) {
    const baseUrl = '/GetActivePrinciple/';
    const payload = {
        uuid: params.uuid,
    }
    // console.log( payload);
    return api.create(`${baseUrl}`, payload);
}
function GetConcentration(params: { uuid: string, active_principle_id: string }) {
    const baseUrl = '/GetConcentration/';
    const payload = {
        uuid: params.uuid,
        activePrinciple: params.active_principle_id,
    }
    //   console.log( payload);
    return api.create(`${baseUrl}`, payload);
}
function GetPharmaceuticalForm(params: { uuid: string, concentration_id: string }) {
    const baseUrl = '/GetPharmaceuticalForm/';
    const payload = {
        uuid: params.uuid,
        concentration: params.concentration_id,
    }
    //  console.log( payload);
    return api.create(`${baseUrl}`, payload);
}

/*******************************************************************************/
function getUserStatisticsDoctor(params: { uuid_user: string }) {
    const baseUrl = '/getUserStatisticsDoctor/';
    const payload = {
        uuid: params.uuid_user,

    }

    return api.create(`${baseUrl}`, payload);
}
/************************************************************************************/


function getUserPathologiesSingle(params: { uuid: string, PathologyUserId: number }) {
    const baseUrl = '/GetUserPathologiesSingle/';
    const payload = {
        uuid: params.uuid,
        PathologyUserId: params.PathologyUserId,
    }
    // console.log( payload);
    return api.create(`${baseUrl}`, payload);
}
function getUserPathologies(params: { uuid: string, uuid_edit: string }) {
    const baseUrl = '/GetUserPathologies/';
    const payload = {
        uuid: params.uuid,
        uuid_edit: params.uuid_edit
    }
    // console.log( payload);
    return api.create(`${baseUrl}`, payload);
}
function getPathologies(params: { uuid: string, category: string }) {
    const baseUrl = '/GetPathologies/';
    const payload = {
        uuid: params.uuid,
        category: params.category,
    }
    //  console.log( payload);
    return api.create(`${baseUrl}`, payload);
}
function getCategoriesPathology(params: { uuid: string }) {
    const baseUrl = '/GetCategoriesPathology/';
    const payload = {
        uuid: params.uuid,
    }
    // console.log( payload);
    return api.create(`${baseUrl}`, payload);
}
function PathologyUser(user: PathologyUserData) {
    const baseUrl = '/PathologyUser/';
    const payload = user

    return api.create(`${baseUrl}`, payload);
}
function UpdatePathologyUser(user: UpdatePathologyUserData) {
    const baseUrl = '/UpdatePathologyUser/';
    const payload = user
    // console.log(user)
    return api.create(`${baseUrl}`, payload);
}
function DeletePathologyUser(user: UpdatePathologyUserData) {
    const baseUrl = '/DeletePathologyUser/';
    const payload = user
    // console.log(user)
    return api.create(`${baseUrl}`, payload);
}

function DeleteMedicineUser(user: UpdateMedicineUserData) {
    const baseUrl = '/DeleteTreatmentUser/';
    const payload = user
    // console.log(user)
    return api.create(`${baseUrl}`, payload);
}

function getUserMedicines(params: { uuid: string, uuid_edit: string }) {
    const baseUrl = '/GetUserMedicines/';
    const payload = {
        uuid: params.uuid,
        uuid_edit: params.uuid_edit
    }
    // console.log( payload);
    return api.create(`${baseUrl}`, payload);
}

function getUserMedicinesSingle(params: { uuid: string, MedicineUserId: number }) {
    const baseUrl = '/GetUserMedicinesSingle/';
    const payload = {
        uuid: params.uuid,
        MedicineUserId: params.MedicineUserId,
    }
    console.log(payload);
    return api.create(`${baseUrl}`, payload);
}
function getMedicines(params: { uuid: string }) {
    const baseUrl = '/GetMedicines/';
    const payload = {
        uuid: params.uuid,
    }
    // console.log( payload);
    return api.create(`${baseUrl}`, payload);
}
function MedicineUser(user: MedicineUserData) {
    const baseUrl = '/MedicineUser/';
    const payload = user

    return api.create(`${baseUrl}`, payload);
}
function UpdateTreatmentUser(user: UpdateMedicineUserData) {
    const baseUrl = '/UpdateTreatmentUser/';
    const payload = user
    // console.log(user)
    return api.create(`${baseUrl}`, payload);
}
function getParameters(params: { name: string }) {
    const baseUrl = '/getParameters/';
    const payload = {
        name: params.name
    }
    // console.log('Clients');
    return api.create(`${baseUrl}`, payload);
}

function getParametersDomain(params: { name: string, Audience: string, Permisology: string }) {
    const baseUrl = '/getParametersDomain/';
    const payload = {
        name: params.name
        , Audience: params.Audience
        , Permisology: params.Permisology
    }
    // console.log('Clients');
    return api.create(`${baseUrl}`, payload);
}
function CreateUserForDoctor(user: UpdateUserData) {
    const baseUrl = '/CreateUserForClient/';
    const payload = user

    console.log('user')
    console.log(user)
    return api.create(`${baseUrl}`, payload);
}

export {
    getUserData, updateUser, getUserClinic,
    getUsers, getUserInfo, getUserPathologies, getPathologies, getCategoriesPathology
    , PathologyUser, UpdatePathologyUser, DeletePathologyUser
    , getMedicines, getUserMedicines, MedicineUser, DeleteMedicineUser, UpdateTreatmentUser
    , GetActivePrinciple, GetConcentration, GetPharmaceuticalForm, getUserPathologiesSingle
    , getUserMedicinesSingle, getUserStatisticsDoctor
    , getParameters, getParametersDomain, CreateUserForDoctor, getUserParameters, updateUserParameters, getUserNotifications, setParameterState
    , updateUserParameters2, updateUserParameters4

};
